import { render, staticRenderFns } from "./ProductForCellFields.vue?vue&type=template&id=d18f74d8&scoped=true"
import script from "./ProductForCellFields.vue?vue&type=script&lang=js"
export * from "./ProductForCellFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18f74d8",
  null
  
)

export default component.exports